export enum ListingType {
    BUY_NOW = "BUY_NOW",
    AUCTION = "AUCTION",
}
